import { useMutation, useQueryClient } from "react-query";
import { ActionLabel } from "utils/types";

import client from "../../Client";

export interface ColumnPriceFormData {
    active: boolean;
    new: boolean;
    price_id: string;
    shop_id: string;
    category_id: string;
    kind_id: string;
    deactivated_labels: string[];
    action_labels: ActionLabel[];
}

export const useEditShopToPrice = () => {
    const queryClient = useQueryClient();

    return useMutation(
        ({ id, data }: { id: string; data: ColumnPriceFormData }) =>
            client.put(`/v1/shops-to-prices/${id}`, data).then((res) => res.data),
        {
            onSuccess: (_, variables) => {
                queryClient.invalidateQueries(["shop-to-price", variables.id]);
                window.location.reload();
            },
        }
    );
};
